export default "__VITE_ASSET__CktFjL6g__"